import axios, { AxiosInstance } from "axios";
import { environment } from "../environment";

export class RssServiceApi {
  axios: AxiosInstance;

  constructor() {
    this.axios = axios.create({
      baseURL: environment.rssApiUrl,
    });
  }
}
